<div class="main-content table-page table-page--compact table-page--dense parametros-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Parámetros de asistencia</h1>
        <p>Con qué reglas se evalúa a su gente. Cada empresa fija las suyas.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn"
                [disabled]="guardando || loading || !!errorCarga" (click)="guardar()">
          <span class="material-icons">save</span>
          {{ guardando ? "Guardando…" : "Guardar" }}
        </button>
      </div>
    </section>

    <section class="table-page__card" *ngIf="loading">
      <div class="table-page__empty table-page__empty--loading">
        <span class="material-icons">hourglass_top</span>
        <h3>Consultando parámetros</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="!loading && errorCarga">
      <div class="table-page__empty">
        <span class="material-icons">error_outline</span>
        <h3>No se pudieron consultar los parámetros</h3>
        <p class="parametros-page__motivo">{{ errorCarga }}</p>
        <button type="button" mat-stroked-button (click)="consultar()">Reintentar</button>
      </div>
    </section>

    <ng-container *ngIf="!loading && !errorCarga">
      <!-- El rechazo del servidor, en rojo y junto al botón Guardar. Lo
           capturado se queda en los campos para corregirlo. -->
      <div class="parametros-page__error" role="alert" *ngIf="errorGuardado">
        <span class="material-icons" aria-hidden="true">error_outline</span>
        <p>
          <strong>{{ errorGuardado }}</strong>
          <span>No se guardó nada; lo que capturó sigue en pantalla.</span>
        </p>
      </div>

      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Puntualidad</h2>
          <p>Cuándo se considera que alguien llegó tarde, y cuándo eso pasa a ser falta.</p>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Tolerancia en minutos</mat-label>
            <input matInput aria-label="Tolerancia en minutos" type="number" min="0" [(ngModel)]="config.minutosTolerancia" />
            <mat-hint>Se usa cuando la plantilla de horario no define la suya.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Cómo se declara una falta</mat-label>
            <mat-select [(ngModel)]="config.reglaFalta">
              <mat-option value="SIN_CHECADA">Solo si no registra</mat-option>
              <mat-option value="UMBRAL_MINUTOS">Si llega después de cierto retraso</mat-option>
              <mat-option value="ACUMULACION_RETARDOS">Acumulando retardos</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" *ngIf="usaUmbral">
            <mat-label>Minutos de retraso que ya son falta</mat-label>
            <input matInput aria-label="Minutos de retraso que ya son falta" type="number" min="1" [(ngModel)]="config.minutosUmbralFalta" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="usaAcumulacion">
            <mat-label>Retardos que suman una falta</mat-label>
            <input matInput aria-label="Retardos que suman una falta" type="number" min="1" [(ngModel)]="config.retardosPorPeriodo" />
            <mat-hint>Cada bloque de esta cantidad, no todo lo que pase de ella.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" *ngIf="usaAcumulacion">
            <mat-label>Periodo de acumulación</mat-label>
            <mat-select [(ngModel)]="config.periodoAcumulacion">
              <mat-option value="SEMANAL">Semanal</mat-option>
              <mat-option value="QUINCENAL">Quincenal</mat-option>
              <mat-option value="MENSUAL">Mensual</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </section>

      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Cierre del día</h2>
          <p>A qué hora se deja de admitir registros y se declaran las faltas de quien no registró.</p>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Hora de corte</mat-label>
            <input matInput type="time" required aria-label="Hora de corte" [(ngModel)]="config.horaCorteFalta" />
            <mat-hint>En la zona horaria de esta empresa.</mat-hint>
            <mat-error>Indique la hora de corte.</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Zona horaria</mat-label>
            <mat-select [(ngModel)]="config.zonaHorariaDefault">
              <mat-option *ngFor="let zona of zonas" [value]="zona">{{ zona }}</mat-option>
            </mat-select>
            <mat-hint>Decide a qué día pertenece cada checada.</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Evaluar desde</mat-label>
            <input matInput aria-label="Evaluar desde" [matDatepicker]="inicioPicker" [(ngModel)]="config.fechaInicioEvaluacion" />
            <mat-datepicker-toggle matIconSuffix [for]="inicioPicker"></mat-datepicker-toggle>
            <mat-datepicker #inicioPicker></mat-datepicker>
            <mat-hint>Sin esta fecha, el primer cierre marca falta a toda la plantilla.</mat-hint>
          </mat-form-field>
        </div>
      </section>

      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Registro desde el teléfono</h2>
          <p>Qué se le exige a quien registra fuera de un kiosco.</p>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Verificación exigida</mat-label>
            <mat-select [(ngModel)]="config.nivelVerificacionRemota">
              <mat-option value="BIOMETRIA_DISPOSITIVO">Huella o rostro del teléfono</mat-option>
              <mat-option value="NINGUNA">Ninguna</mat-option>
            </mat-select>
            <mat-hint>La biometría no sale del teléfono; el servidor solo recibe «verificado».</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Teléfonos por persona</mat-label>
            <input matInput aria-label="Teléfonos por persona" type="number" min="1" [(ngModel)]="config.dispositivosPorEmpleado" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Desfase máximo sin conexión (minutos)</mat-label>
            <input matInput aria-label="Desfase máximo sin conexión (minutos)" type="number" min="0" [(ngModel)]="config.minutosMaxDesfaseOffline" />
            <mat-hint *ngIf="!desfaseDesactivado">
              El servidor no puede comprobar que de verdad no había señal.
            </mat-hint>
            <mat-hint *ngIf="desfaseDesactivado">
              En cero: la hora la pone siempre el servidor. Se pierden las checadas hechas sin cobertura.
            </mat-hint>
          </mat-form-field>
        </div>

        <div class="parametros-page__toggles">
          <mat-slide-toggle [(ngModel)]="config.cambioDispositivoRequiereAprobacion">
            Un teléfono nuevo necesita aprobación antes de poder registrar
          </mat-slide-toggle>
          <p class="parametros-page__nota">
            Un teléfono nuevo llega a la bandeja de Teléfonos hasta que alguien lo autoriza.
          </p>
        </div>
      </section>

      <section class="table-page__card parametros-page__bloque">
        <header class="parametros-page__encabezado">
          <h2>Modalidad mixta y visibilidad</h2>
        </header>

        <div class="parametros-page__grid">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Mixto del mismo día</mat-label>
            <mat-select [(ngModel)]="config.modoMixtoDia">
              <mat-option value="DECLARADO">Lo declara la persona</mat-option>
              <mat-option value="INFERIDO">Se infiere del canal de cada registro</mat-option>
            </mat-select>
            <mat-hint>Inferido: huella en la mañana y teléfono en la tarde se lee como mixto.</mat-hint>
          </mat-form-field>
        </div>

        <div class="parametros-page__toggles">
          <mat-slide-toggle [(ngModel)]="config.mostrarVeredictoEmpleado">
            Mostrar al empleado el veredicto de su día
          </mat-slide-toggle>
          <p class="parametros-page__nota">
            Apagado, la persona ve sus horas pero no el veredicto del día.
          </p>
        </div>
      </section>
    </ng-container>
  </div>
</div>
